
import { defineComponent, computed, ref, reactive } from "vue";

export default defineComponent({
  name: "App",
  components: {},
  setup() {
    const inputNum = ref(0);
    const appleObj = reactive({
      name: "リンゴ",
      price: 100,
    });

    // computed
    const calcSum = computed(() => {
      return appleObj.price * inputNum.value;
    });

    return {
      inputNum,
      appleObj,
      calcSum,
    };
  },
});
